export const copy = {
		'title': 'How did you end up here?',
		'blurb': "The page you're looking for doesn't exist.",
		'try': {
				'blurb': 'A couple of things you can try:',
				'options': [
						'Did you type in a web address to get here? Check you typed it in correctly.',
						'Try to find the page you were looking for by clicking My Account.'
				]
		}
};



// WEBPACK FOOTER //
// ./src/app/containers/NotFound/notFound-copy.ts